import styled from 'styled-components';

import { colors } from '@soluto-private/mx-asurion-ui-react';

export const GoogleMapMarker = styled.div<{
  color?: string;
  lat: number;
  lng: number;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  background: ${(props) => (props.color ? props.color : colors.primaryDeep)};
  border-radius: 9999px;
  min-width: 35px;
  min-height: 35px;
  left: calc(-48px / 2);
  top: calc(-48px - 5px);

  &:after {
    position: absolute;
    bottom: -14px;
    left: 50%;
    transform: translateX(-50%);
    border: 8px solid transparent;
    border-top-color: ${(props) =>
      props.color ? props.color : colors.primaryDeep};
    content: '';
  }
`;
